export const fullNameRequiredMsg = 'Full name is required';
export const fullNameInvalidMsg = 'Enter a full name';
export const firstNameRequiredMsg = 'First name is required';
export const firstNameInvalidMsg = 'Enter a valid first name';
export const firstNameMaxCharactersMsg = 'First name cannot exceed 70 characters';
export const lastNameRequiredMsg = 'Last name is required';
export const lastNameInvalidMsg = 'Enter a valid last name';
export const lastNameMaxCharactersMsg = 'Last name cannot exceed 70 characters';
export const phoneRequiredMsg = 'Phone number is required';
export const phoneInvalidMsg = 'Enter a valid phone number';

export const nameOnCardRequiredMsg = 'Name on card is required';
export const expirationDateRequiredMsg = 'Expiration is required';
export const expirationDateWrongLengthMsg = 'Expiry date is the wrong length';
export const expirationDateOldErrorMsg = 'Expiry date: card too old';
export const expirationDateFutureErrorMsg = 'Expiry date: date too far in the future';
